import { lockBodyScroll, unlockBodyScroll } from "./scroll-lock";

document.addEventListener("DOMContentLoaded", () => {
    const loginButton = document.querySelector('button[name="provider"][value="UmbracoMembers.OpenIdConnect"]') as HTMLButtonElement;
    const modal = document.getElementById("first-visit-modal");
    if (!modal) return;

    if (localStorage.getItem("hasVisitedBefore")) return;

    const content = modal.querySelector<HTMLElement>("[data-modal-content]");
    const dismissButtons = modal.querySelectorAll<HTMLButtonElement>("[data-modal-dismiss]");
    const modalLoginButton = modal.querySelector<HTMLButtonElement>("[data-modal-visit-login]");

    const setState = (state: "open" | "closed") => {
        modal.dataset.state = state;
        if (state === "open") lockBodyScroll("first-visit");
        else unlockBodyScroll("first-visit");
        if (state === "closed") {
            try {
                localStorage.setItem("hasVisitedBefore", "true");
            } catch (e) {
                console.warn("Could not save in localStorage:", e);
            }
        }
    };

    const isOpen = () => modal.dataset.state === "open";

    if (!localStorage.getItem("hasVisitedBefore")) {
        setState("open");
    }

    modal.addEventListener("click", e => {
        if (e.target === modal && isOpen()) setState("closed");
    });

    content?.addEventListener("click", e => e.stopPropagation());

    dismissButtons.forEach(btn => btn.addEventListener("click", () => setState("closed")));
    modalLoginButton.addEventListener("click", () => {
        loginButton.click();
    });

    document.addEventListener("keydown", e => {
        if (e.key === "Escape" && isOpen()) {
            setState("closed");
        }
    });
});
